import React, { useState, useEffect } from 'react';
import useInView from '../hooks/useInView';
import { TESTIMONIALS } from '../data';

const TestimonialsSection = ({ dark, t }) => {
  const [ref, inView] = useInView(0.1);
  const [active, setActive] = useState(0);

  // Auto-rotate
  useEffect(() => {
    const id = setInterval(() => setActive((a) => (a + 1) % TESTIMONIALS.length), 4000);
    return () => clearInterval(id);
  }, []);

  return (
    <section
      id="testimonials"
      style={{ padding: '120px 32px', background: t.bg, position: 'relative', overflow: 'hidden' }}
    >
      {/* Soft radial glow */}
      <div
        style={{
          position: 'absolute', top: '50%', left: '50%',
          transform: 'translate(-50%,-50%)',
          width: '120%', height: '120%',
          background: dark
            ? 'radial-gradient(ellipse at center,rgba(201,162,39,0.04) 0%,transparent 60%)'
            : 'radial-gradient(ellipse at center,rgba(201,162,39,0.08) 0%,transparent 60%)',
          pointerEvents: 'none',
        }}
      />

      <div ref={ref} style={{ maxWidth: 1280, margin: '0 auto', position: 'relative', zIndex: 1 }}>
        {/* Header */}
        <div
          style={{
            textAlign: 'center',
            marginBottom: 72,
            opacity: inView ? 1 : 0,
            animation: inView ? 'fadeUp 0.7s cubic-bezier(.16,1,.3,1) forwards' : 'none',
          }}
        >
          <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 12, color: t.gold, letterSpacing: 3, textTransform: 'uppercase', marginBottom: 16, fontWeight: 600 }}>
            — Client Stories —
          </div>
          <h2 style={{ fontFamily: "'Cormorant Garamond',serif", fontWeight: 700, fontSize: 'clamp(2.2rem,4vw,3.5rem)', color: t.text }}>
            What Our <span className="gold-text">Clients Say</span>
          </h2>
        </div>

        {/* Cards */}
        <div className="three-col" style={{ display: 'grid', gridTemplateColumns: 'repeat(3,1fr)', gap: 28 }}>
          {TESTIMONIALS.map((tm, i) => (
            <div
              key={tm.name}
              onClick={() => setActive(i)}
              style={{
                padding: 36,
                borderRadius: 20,
                background: i === active ? (dark ? '#181818' : '#fff') : t.surfaceB,
                border: `1.5px solid ${i === active ? t.gold : t.border}`,
                transition: 'all 0.5s cubic-bezier(.16,1,.3,1)',
                transform: i === active ? 'translateY(-8px) scale(1.02)' : 'translateY(0) scale(1)',
                boxShadow: i === active
                  ? dark ? '0 24px 60px rgba(0,0,0,0.5),0 0 0 1px rgba(201,162,39,0.2)' : '0 24px 60px rgba(0,0,0,0.1)'
                  : 'none',
                cursor: 'pointer',
                opacity: inView ? 1 : 0,
                animation: inView ? `fadeUp 0.6s ${0.1 * i}s cubic-bezier(.16,1,.3,1) forwards` : 'none',
              }}
            >
              {/* Stars */}
              <div style={{ display: 'flex', gap: 2, marginBottom: 20 }}>
                {'★★★★★'.split('').map((s, j) => (
                  <span key={j} style={{ color: '#c9a227', fontSize: 20 }}>{s}</span>
                ))}
              </div>

              {/* Quote */}
              <p
                style={{
                  fontFamily: "'Cormorant Garamond',serif",
                  fontSize: 19, fontStyle: 'italic',
                  color: t.text, lineHeight: 1.65, marginBottom: 24,
                }}
              >
                "{tm.text}"
              </p>

              {/* Author */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
                <div
                  style={{
                    width: 46, height: 46, borderRadius: '50%', flexShrink: 0,
                    background: 'linear-gradient(135deg,#c9a227,#e8c040)',
                    display: 'flex', alignItems: 'center', justifyContent: 'center',
                    fontFamily: "'Cormorant Garamond',serif", fontWeight: 700, fontSize: 20, color: '#0a0a0a',
                  }}
                >
                  {tm.name[0]}
                </div>
                <div>
                  <div style={{ fontFamily: "'DM Sans',sans-serif", fontWeight: 600, fontSize: 15, color: t.text }}>
                    {tm.name}
                  </div>
                  <div style={{ fontFamily: "'DM Sans',sans-serif", fontSize: 13, color: t.textMuted }}>
                    {tm.loc} · {tm.loan}
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>

        {/* Dot indicators */}
        <div style={{ display: 'flex', justifyContent: 'center', gap: 8, marginTop: 40 }}>
          {TESTIMONIALS.map((_, i) => (
            <button
              key={i}
              onClick={() => setActive(i)}
              style={{
                width: i === active ? 32 : 8,
                height: 8,
                borderRadius: 4,
                border: 'none',
                cursor: 'pointer',
                background: i === active
                  ? 'linear-gradient(90deg,#c9a227,#e8c040)'
                  : 'rgba(201,162,39,0.3)',
                transition: 'all 0.4s cubic-bezier(.16,1,.3,1)',
              }}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default TestimonialsSection;
